export default __webpack_public_path__ + "static/media/Iconica.1c8373c1.png";